import {Service} from "@/apiServices/Service";

export class FiscalesService extends Service {
    constructor() {
        super('fiscales/');
    }


    obtenerRecibosPagadosPorPaciente(idPaciente) {
        this.onStart();
        return this.http.get(this.getUrl(['obtener', 'recibos','pagados'], {idPaciente}))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


}
